







































import { defineComponent, ref } from '@vue/composition-api';
import { DataTableHeader } from 'vuetify';
import { ApiKey } from '../../store/types';
import ApiKeyCreateButton from './ApiKeyCreateButton.vue';
import ApiKeyRevokeButton from './ApiKeyRevokeButton.vue';

export default defineComponent({
	components: {
		ApiKeyCreateButton,
		ApiKeyRevokeButton,
	},
	props: {
		apiKeys: {
			type: Array as () => Array<ApiKey>,
			required: true,
		},
	},
	setup() {
		const search = ref<string>('');

		const headers: DataTableHeader[] = [
			{ text: 'Label', value: 'label' },
			{ text: '', value: 'actions', sortable: false, align: 'end' },
		];

		return {
			headers,
			search,
		};
	},
});
